import '../controllers';

import * as Turbo from '@hotwired/turbo';
import { startFunnelTracking } from '../lib/funnel';
import { startAdConversions } from '../lib/ad_conversions';
import { installEdgePageCsrf } from '../lib/edge_page_csrf';
import * as ActiveStorage from '@rails/activestorage';

ActiveStorage.start();
// Hover prefetch (Turbo 8) is turned off by <meta name="turbo-prefetch"> in
// layouts/_site_head.html.erb.
Turbo.start();
startFunnelTracking();
startAdConversions();
installEdgePageCsrf();
// A Turbo visit can land on an edge-cached page after a page that had a session.
document.addEventListener('turbo:load', installEdgePageCsrf);

if (import.meta.env.DEV) {
  Turbo.session.drive.cacheSize = 0;
}

// A deploy replaces every hashed chunk under /vite/assets. A page loaded before the deploy
// then 404s when it lazy-imports a chunk ("Failed to fetch dynamically imported module").
// Vite reports that through vite:preloadError; a reload picks up the new asset manifest.
// The timestamp guard stops a reload loop if the chunk is genuinely broken.
const STALE_CHUNK_RELOAD_KEY = 'vite-stale-chunk-reload-at';
const STALE_CHUNK_RELOAD_WINDOW_MS = 30_000;

window.addEventListener('vite:preloadError', (event) => {
  let lastReloadAt = 0;
  try {
    lastReloadAt = Number(sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) || 0;
  } catch {
    // sessionStorage unavailable; fall through and reload once.
  }
  if (Date.now() - lastReloadAt < STALE_CHUNK_RELOAD_WINDOW_MS) return;

  try {
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // ignore
  }
  event.preventDefault();
  window.location.reload();
});

function maybeLoadSentryBrowser() {
  if (!document.querySelector('meta[name="sentry-browser"]')) return;
  import('../lib/sentry_client').then((mod) => mod.initSentryBrowser());
}

function maybeLoadAdminForms() {
  if (document.querySelector('script[src*="admin_forms"]')) return;
  if (document.querySelector('trix-editor, .form-select')) {
    import('./admin_forms.js');
  }
}

document.addEventListener('turbo:load', maybeLoadAdminForms);
maybeLoadAdminForms();
maybeLoadSentryBrowser();
document.addEventListener('turbo:load', maybeLoadSentryBrowser);
